import { Box, Button, Stack } from "@mui/material";
import React from "react";
import PageTitle from "./PageTitle";
import { GlassButton } from "../themes/UiElements";

const TopTitleActions = ({ title, actions = [] }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        justifyContent: "space-between",
        alignItems: { xs: "flex-start", sm: "center" },
        gap: 2,
        mb: 3,
      }}
    >
      <PageTitle>{title}</PageTitle>

      {actions.length > 0 && (
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={1}
          sx={{
            width: { xs: "100%", sm: "auto" },
            mt: { xs: 1, sm: 0 },
          }}
        >
          {actions.map((item, index) => (
            <GlassButton
              key={index}
              variant="contained"
              startIcon={item.icon}
              onClick={item.action}
              sx={{ width: { xs: "100%", sm: "auto" } }}
            >
              {item.label}
            </GlassButton>
          ))}
        </Stack>
      )}
    </Box>
  );
};

export default TopTitleActions;
